/**
 * Route paths that more than one file needs to agree on.
 *
 * A path written as a literal in both `app.routes.ts` and a guard can drift
 * silently: the guard keeps redirecting to a path that no longer exists, and
 * the router falls through to whatever matches next. Naming it once here makes
 * a rename a compile-time change.
 */

/**
 * The explicit 404 route, declared just before the catch-all `**` in
 * `app.routes.ts`. Both render `NotFoundComponent`.
 *
 * The catch-all already covers mistyped URLs. This named path lets a guard
 * render the same 404 for a page that exists but must look absent, with
 * `skipLocationChange: true` so `/not-found` never shows in the address bar.
 * No guard uses it today — `isAdminGuard` sent non-admins here until
 * 2026-10-14, when the P.O. replaced that with a toast and the Dashboard.
 */
export const NOT_FOUND_PATH = 'not-found';

/**
 * The Dashboard — where a user is sent when they may not open the page they
 * asked for (see `isAdminGuard`).
 */
export const DASHBOARD_URL = '/mbrs/dashboard';

/**
 * The XBRL Files listing — where a conversion that cannot be opened sends the
 * user (the container's post-load redirect and `conversionExistsGuard`'s
 * cold-load redirect), because it is where a valid one can be picked.
 */
export const XBRL_FILES_URL = '/mbrs/xbrl-files';

/**
 * User Management — the SuperAdmin's home page (a SuperAdmin may open nothing
 * else under /mbrs; see `canUseConversionsGuard`) and where
 * `SUPERADMIN_MODULE_FORBIDDEN` sends them.
 */
export const USER_MANAGEMENT_URL = '/mbrs/user-management';
